export enum EnvironmentPages {
  OVERVIEW = 'OVERVIEW',
  ENDPOINTS = 'ENDPOINTS',
  RELEASE_PACKAGE = 'RELEASE_PACKAGE',
  SFTP = 'SFTP',
  BASE_IMAGE = 'BASE_IMAGE',
  DATABASE_BACKUP = 'DATABASE_BACKUP',
  PRODUCT_RVTS = 'PRODUCT_RVTS',
  SANITY_TEST = 'SANITY_TEST',
  EF_TEST = 'EF_TEST',
  COB = 'COB',
  RUNBOOK = 'RUNBOOK',
  SCHEDULES = 'SCHEDULES',
  JOBS = 'JOBS',
  START_STOP = 'START_STOP',
  ACTIVITY = 'ACTIVITY',
  INVENTORY = 'INVENTORY',
  METRICS = 'METRICS',
  VERSION_MANAGER = 'VERSION_MANAGER',
  SETTINGS = 'SETTINGS',
  LOCAL_CONFIGURATION = 'LOCAL_CONFIGURATION',
  CUSTOM_PACKAGE = 'Custom Package',
  COMPONENT_UPDATE = 'Component Update',
  SIZING_DOCUMENTS = 'SIZING DOCUMENTS',
  UPDATE_MANAGER  = 'Update Manager',
  DEPENDENCY_TREE = 'DEPENDENCY_TREE'
}

export const environmentPages = Object.values(EnvironmentPages);
